import { css } from 'styled-components';

class CssTransition {
    constructor(cssAnimation = {}) {
        this.cssAnimation = cssAnimation;
    }
    getCss(state) {
        var _a, _b;
        return css `
      ${(_a = this.cssAnimation[state]) === null || _a === void 0 ? void 0 : _a.property.name}: ${(_b = this.cssAnimation[state]) === null || _b === void 0 ? void 0 : _b.property.value};
      ${this.getTransition(state)}
    `;
    }
    getTransition(state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!((_a = this.cssAnimation[state]) === null || _a === void 0 ? void 0 : _a.transition)) {
            return '';
        }
        return css `
      transition-property: ${((_c = (_b = this.cssAnimation[state]) === null || _b === void 0 ? void 0 : _b.transition) === null || _c === void 0 ? void 0 : _c.property) || 'all'};
      transition-duration: ${((_e = (_d = this.cssAnimation[state]) === null || _d === void 0 ? void 0 : _d.transition) === null || _e === void 0 ? void 0 : _e.duration) || 0}ms;
      transition-timing-function: ${((_g = (_f = this.cssAnimation[state]) === null || _f === void 0 ? void 0 : _f.transition) === null || _g === void 0 ? void 0 : _g.timing) || 'ease'};
      transition-delay: ${((_j = (_h = this.cssAnimation[state]) === null || _h === void 0 ? void 0 : _h.transition) === null || _j === void 0 ? void 0 : _j.delay) || 0};
    `;
    }
}

export { CssTransition };
//# sourceMappingURL=CssTransition.js.map
